import type {
  CancelClubTableRequest,
  CancelClubTableResponse
} from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import type { HgEmptyReply } from '@ps/web-shared-api-types/v1-preview/SwHomeGames/CancelClubTableResponse';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { lastValueFrom } from 'rxjs';

import useRequest from '@swf/core/hooks/useRequest';
import type { Dispatch } from '@swf/core/store';
import { handleServerResponse, useHomeGamesWidget } from '@swf/poker';

import ENDPOINTS from '../constants/endpoints';
import { ModalRoutes } from '../types/common';

import { TXTSRV_SorryX_we_are_experiencing_tem_ELL } from './useDeleteCashGame.messages.json';

export interface RequestBody {
  body: CancelClubTableRequest;
}

const useDeleteCashGame = (widgetId?: string) => {
  const request = useRequest();
  const { modal } = useDispatch<Dispatch>();
  const [loading, setLoading] = useState(false);
  const { widgetDispatch } = useHomeGamesWidget(widgetId);
  const { formatMessage } = useIntl();

  const handleDeleteCashGame = useCallback(
    async ({ body }: RequestBody) => {
      setLoading(true);

      try {
        const response = await lastValueFrom(
          request<CancelClubTableResponse>({
            service: ENDPOINTS.clubTableCancel,
            body,
            method: 'DELETE',
            http: true
          })
        );

        const { error } = handleServerResponse<CancelClubTableResponse, HgEmptyReply>({
          response: response.body,
          accessor: 'hgCancelCashGameReply'
        });
        setLoading(false);
        modal.close();

        if (error) {
          modal.enqueue({
            path: ModalRoutes.notification,
            locationState: { text: error }
          });
        } else {
          widgetDispatch.fetchClubInfo();
          window.starsweb?.homegames?.refresh?.();
        }
      } catch (_) {
        modal.enqueue({
          path: ModalRoutes.notification,
          locationState: { text: formatMessage(TXTSRV_SorryX_we_are_experiencing_tem_ELL) }
        });
      }
    },
    [formatMessage, modal, request, widgetDispatch]
  );

  return { handleDeleteCashGame, loading };
};

export default useDeleteCashGame;
